import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { togglePanel } from '../../../../state/actions/panels/index.tsx';
import { getIsCompanyManaged, getRapidViewId } from '../../../../state/selectors/app/index.tsx';
import { getShowEpicAsPanel } from '../../../../state/selectors/config/index.tsx';
import { isBacklogWithSprints as isBacklogWithSprintsSelector } from '../../../../state/selectors/sprints/index.tsx';
import { isVersionsFeatureEnabled } from '../../../../state/selectors/version/index.tsx';
import type { State } from '../../../../state/types.tsx';
import { BacklogViewSettings } from './view.tsx';

export default componentWithFG(
	'backlog-view-settings-remove-redux-connect',
	BacklogViewSettings,
	connect(
		(state: State) => ({
			rapidViewId: Number(getRapidViewId(state)),
			isBacklogWithSprints: isBacklogWithSprintsSelector(state),
			isClassic: getIsCompanyManaged(state),
			showEpicAsPanel: getShowEpicAsPanel(state),
			isVersionsEnabled: isVersionsFeatureEnabled(state),
		}),
		{
			onTogglePanel: togglePanel,
		},
	)(BacklogViewSettings),
);
